import { AUTH_STORAGE_KEYS } from '../constants/auth';

/** Disparado pelo Navbar ao trocar empresa/unidade — outras telas ouvem pra refazer suas queries. */
export const TENANT_SCOPE_CHANGED_EVENT = 'tenant-scope:changed';

function dispatchTenantScopeChanged(): void {
  document.dispatchEvent(new Event(TENANT_SCOPE_CHANGED_EVENT));
}

export function getEffectiveTenantId(): string | null {
  return localStorage.getItem(AUTH_STORAGE_KEYS.effectiveTenantId) || null;
}

export function setEffectiveTenantId(tenantId: string | null | undefined): void {
  if (tenantId) {
    localStorage.setItem(AUTH_STORAGE_KEYS.effectiveTenantId, String(tenantId));
  } else {
    localStorage.removeItem(AUTH_STORAGE_KEYS.effectiveTenantId);
  }
  dispatchTenantScopeChanged();
}

export function getEffectiveUnidadeId(): string | null {
  return localStorage.getItem(AUTH_STORAGE_KEYS.effectiveUnidadeId) || null;
}

export function setEffectiveUnidadeId(unidadeId: string | null | undefined): void {
  if (unidadeId) {
    localStorage.setItem(AUTH_STORAGE_KEYS.effectiveUnidadeId, String(unidadeId));
  } else {
    localStorage.removeItem(AUTH_STORAGE_KEYS.effectiveUnidadeId);
  }
}

/** Tenant efetivo para super_admin (header X-Tenant-Id). */
export function resolveXTenantIdHeader(): string | null {
  return getEffectiveTenantId();
}
